import React from 'react';
import { PencilSquareIcon, UserIcon, SparklesIcon } from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import PlaybookCard from '../../../components/playbooks/PlaybookCard';


const TeamHealthChecksFinalThoughts = () => (
  <div className="space-y-8">
    <PlaybookSection title="Final Thoughts" icon={<PencilSquareIcon className="h-7 w-7 text-primary-light" />} heading>
      <PlaybookCard>
        <p className="text-lg text-gray-200">Using this playbook offers you a comprehensive framework for getting started with team health checks. Remember, the goal is not just to collect data, but to create a continuous feedback loop that leads to real improvement and a healthier, more engaged team.</p>
      </PlaybookCard>
      
      
    </PlaybookSection>
  </div>
);

export default TeamHealthChecksFinalThoughts; 